// extracted by mini-css-extract-plugin
export var contentBody = "_48-9";
export var headerImage = "_48-2";
export var imageButton = "_48-7";
export var imageButtonIcon = "_48-8";
export var imageHeader = "_48-4";
export var imageHeaderText = "_48-5";
export var imageOverlay = "_48-3";
export var imageTitle = "_48-6";
export var imageWrapper = "_48-1";
export var taskList = "_48-a";
export var widget = "_48-0";